ACC.cartpage = {
  bindAll: function() {
    $('.ph-cartpage_infomark__icon').on('click', function() {
      var $parent = $(this).closest('.ph-itemproduct');

      $parent.find('.ph-cartpage_product_details__tooltip_text').toggleClass('hidden');
      $parent.siblings().find('.ph-cartpage_product_details__tooltip_text').addClass('hidden');
      $(this).parent().removeClass('ph-repairable_wrapper');
    });
    $(document).on('click', '.ph-repairable', function() {
      $(this).parent().addClass('ph-repairable_wrapper');
      $(this).parent().find('.ph-cartpage_product_details__tooltip_text').toggleClass('hidden');
    });
    $(document).mouseup(function(e) {
      var $container = $('.tooltip__icon');

      if (!$container.is(e.target) && $container.has(e.target).length === 0) {
        $('.tooltip__content').addClass('hidden');
      }
    });

    if ($('.lineitemDetails').html()) {
      $('.lineitemDetails').each(function() {
        var lineitemDetailsContent = $(this).html(),
            $newClassAddededTo = $(this).parents('.ph-cartpage_product_details__tooltip_text');

        if (lineitemDetailsContent.length > 300) {
          $newClassAddededTo.addClass('ph-spclitemwidth');
        } else if (lineitemDetailsContent.length > 180) {
          $newClassAddededTo.addClass('ph-spclitemwidth1');
        }
      });
    }
  },
  compliancyPopupOnLoad: function() {
    if ($('.showCompliancePopup') && $('.showCompliancePopup').text() === 'true') {
      ACC.cartpage.cartCompliancyPopup();
    }
  },
  cartCompliancyPopup: function() {
    var incidentNumber = $('.ph-incidentNumberSSO').val();

    if (ACC.orderReason.$isssoLogin === 'false' && incidentNumber === '') {
      $.colorbox({
        html: $('.ph-acknowledge-selector').html(),
        width: '100%',
        maxWidth: 540,
        height: '80%',
        maxHeight: 400,
        close: '',
        overlayClose: false,
        onComplete: function() {
          $('#colorbox').addClass('ph-topposition');

          if ($(window).width() < 768) {
            $.colorbox.resize();
          }

          $(document).on('click', '.ph-acknowledge-continue', function() {
            $.colorbox.close();
          });
          $(document).on('click', '.ph-acknowledge_button a', function() {
            $('#clearCart').submit();
          });
        },
        onClosed: function() {
          $('#colorbox').removeClass('ph-topposition');
        }
      });
    }
  },
  asmCartDownloadPopup: function() {
    $.colorbox({
      html: $('.ph-downloadpopup').html(),
      width: '100%',
      maxWidth: 750,
      top: 50,
      height: 'auto',
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  ajaxOppId: function() {
    var oppIdFlag = '',
        oppId = '#cboxLoadedContent .ph-oppId',
        downloadButton = 'ph-asm-downloadButton';

    oppIdFlag = $('.ph-oppIdValue').text();

    if (oppIdFlag === 'false') {
      $('.ph-asm-download').attr('href', ACC.config.contextPath + '/printCartToPDF');
    } else {
      $('.ph-asm-download').click(function() {
        ACC.cartpage.asmCartDownloadPopup();

        var oppIdValue = '';

        if ($(oppId).length > 0) {
          $(document).on('keyup', oppId, function() {
            oppIdValue = encodeURIComponent($(oppId).val().trim());

            if (oppIdValue.length > 0) {
              $('.' + downloadButton).attr('href', ACC.config.contextPath + '/printCartToPDF?opportunityId=' + oppIdValue);
            }
          });

          if (oppIdValue.length === 0) {
            $('.' + downloadButton).attr('href', ACC.config.contextPath + '/printCartToPDF');
          }
        }

        $(document).on('click', '.' + downloadButton, function() {
          $.colorbox.close();
        });
      });
    }
  }
};
$(document).ready(function() {
  ACC.cartpage.bindAll();
  ACC.cartpage.ajaxOppId();
  ACC.cartpage.compliancyPopupOnLoad();
  $('#procurementForm').submit();
});
$('input[type="number"]').on('input keydown keyup', function(event) {
  var e = event || window.event;
  var charCode = '';

  if (typeof e.which === 'undefined') {
    charCode = e.keyCode;
  } else {
    charCode = e.which;
  }

  if (charCode > 64 && charCode < 91) {
    e.preventDefault();
  }
});
